(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('socketService', [function () {
            var socketService = {};
            var pusher;
            var channel;

            function init() {
                if (pusher) {
                    return;
                }
                Pusher.logToConsole = config.env !== 'production';

                pusher = new Pusher(config.pusher.key, {
                    cluster: config.pusher.cluster,
                    forceTLS: true,
                });
            }

            socketService.subscribe = function (channelName) {
                init();
                channel = pusher.subscribe(channelName);
            };

            socketService.bind = function (eventName, callback) {
                channel.bind(eventName, callback);
            };
            return socketService;
        }]);
}());
